<template>
  <section class="nav-bar" v-if="menu && menu.length">
    <div class="nav-container">
      <div class="brand">
        <v-icon
          v-if="isMobile && isFocused"
          large
          style="margin-left:-10px; margin-top:-23px; z-index:10"
          @click="MobileBack"
        >
          mdi-arrow-left
        </v-icon>
        <a v-else href="/"><img src="/imgs/logo.png" width="50px"/></a>
      </div>
      <nav>
        <div class="nav-mobile">
          <a id="nav-toggle" @click="openMenu">
            <v-icon>mdi-menu</v-icon>
          </a>
        </div>
        <ul class="nav-list">
          <li v-for="(m, idx) in menu" :key="idx">
            <a href="javascript:void(0)" @click="handleMenuClick(m.MenuUrl)">
              <v-icon>{{ m.MenuIcon }}</v-icon>
              {{ m.MenuName }}
            </a>
            <ul v-if="m.child" class="nav-dropdown">
              <li v-for="(sm, sidx) in m.child" :key="sidx">
                <a
                  href="javascript:void(0)"
                  @click="handleMenuClick(sm.MenuUrl)"
                >
                  {{ sm.MenuName }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <div id="name_div" v-if="user">
        <div>
          <div>SIPMASSE</div>
          <div>{{ user ? user.FullName : '' }}</div>
        </div>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-icon style="padding:0 4px; font-size:xx-large;" v-on="on">
              mdi-account-circle
            </v-icon>
          </template>
          <v-list dense style="width:250px">
            <v-list-item @click="OpenChangePassword">
              <v-list-item-icon>
                <v-icon>mdi-key</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Ganti Password</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="Logout">
              <v-list-item-icon>
                <v-icon>mdi-home-export-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <ChangePassword :show.sync="showChangePassword" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Popover from '@/components/Forms/Popover'
import ChangePassword from '../Admin/ChangePassword'

export default {
  components: {
    Popover,
    ChangePassword,
  },
  data: () => ({
    messages: [],
    showChangePassword: false,
  }),
  computed: {
    ...mapGetters({
      menu: 'getMenu',
      user: 'getUser',
      isFocused: 'isPageFocused',
    }),
    isMobile() {
      return window.innerWidth < window.innerHeight ? 'is-mobile' : ''
    },
  },
  async mounted() {
    setInterval(this.populateMessages, 360000)
  },
  methods: {
    ...mapActions(['setMenu', 'setUser', 'setPageFocused']),
    OpenChangePassword() {
      this.showChangePassword = true
    },
    Logout() {
      this.setMenu([])
      this.setUser(null)
      localStorage.clear()
      sessionStorage.clear()
      this.$router.push('/')
    },
    async populateMessages() {
      // let { data } = await this.$api.call('PRM_SelUserMessages')
      // this.messages = data
    },
    handleMenuClick(url) {
      // evt.target.closest("LI").querySelector("UL").style.display = "initial";
      if (url.match(/^javascript:/)) eval(url)
      else if (url) {
        this.$router.push(url)
        document.querySelector('.nav-list').style.display = 'none'
      }
    },
    openMenu() {
      if (document.querySelector('.nav-list').style.display == 'none')
        document.querySelector('.nav-list').style.display = 'initial'
      else document.querySelector('.nav-list').style.display = 'none'
    },
    MobileBack() {
      this.setPageFocused(false)
      document.querySelector('.page').scrollLeft = 0
    },
    MessageClick(item) {
      this.$router.push({
        path: `/Main/RTLH/InputProposal/`,
        query: {
          NIK: item.NIK,
          Kabupaten: item.Kabupaten,
          Kecamatan: item.Kecamatan,
          Kelurahan: item.Kelurahan,
          Tahun: item.Tahun,
          ProposalID: item.ProposalID,
          tabId: 2,
        },
      })
    },
  },
}
</script>
<style lang="scss">
.nav-bar {
  height: 50px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);

  ul {
    padding-left: 0px !important;
    z-index: 10;
  }
  .nav-list {
    li:hover {
      & > ul {
        display: initial;
      }
    }
  }
}

.brand {
  position: absolute;
  padding-left: 20px;
  float: left;
  line-height: 70px;
  text-transform: uppercase;
  font-size: 1.4em;
}
.brand a img {
  max-height: 70px;
}
.brand a,
.brand a:visited {
  color: #ffffff;
  text-decoration: none;
}

.nav-container {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
}

nav {
  /* float: right;
  left: 100px;*/
  margin-left: 80px;
  position: relative;
  z-index: 2;

  .v-icon {
    position: relative;
    top: -1.5px;
    color: silver !important;
  }
}
nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
nav ul li {
  float: left;
  position: relative;
}
nav ul li a,
nav ul li a:visited {
  display: block;
  padding: 0 20px;
  line-height: 50px;
  /* background: #262626;
  color: #ffffff !important; */
  background: white;
  color: #333 !important;
  text-decoration: none;
}
nav ul li a:hover,
nav ul li a:visited:hover {
  background: #5778fa;
  color: #ffffff !important;
  .v-icon {
    position: relative;
    top: -1.5px;
    color: #ffffff !important;
  }
}
nav ul li a:not(:only-child):after,
/*nav ul li a:visited:not(:only-child):after {
  padding-left: 4px;
  content: ' ▾';
}*/
nav ul li ul li {
  min-width: 190px;
}
nav ul li ul li a {
  padding: 15px;
  line-height: 20px;
}

.nav-dropdown {
  position: absolute;
  display: none;
  z-index: 1;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.15);
}
.nav-mobile {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  /* background: #262626; */
  height: 50px;
  width: 70px;
}
#bell_popover {
  border-radius: 3px;
  padding: 5px 8px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 5px;
  width: 300px;
  margin-left: -280px;
  cursor: pointer;
  max-height: 250px;
  overflow-y: auto;
}
#bell_div {
  float: right;
  padding: 12px 0;
}
#name_div {
  /*display: inline-block;
  position: absolute;
  right: calc(50vw - 462px);
  top: 13px;*/
  color: gray;
  font-size: small;
  text-align: right;
  padding: 6px;
  position: absolute;
  right: 10px;
  display: flex;
}

@media only screen and (max-width: 798px) {
  .nav-mobile {
    display: block;
  }

  #bell_div {
    top: 3px;
    position: absolute;
    right: 70px;
    z-index: 100;
  }
  #name_div {
    right: 50px;
    z-index: 1000;
  }
  nav {
    width: 100%;
    padding: 70px 0 15px;
    left: 0;
  }
  nav ul {
    display: none;
  }
  nav ul li {
    float: none;
  }
  nav ul li a {
    padding: 15px;
    line-height: 20px;
    padding-left: 25%;
  }
  nav ul li ul li a {
    padding-left: 30%;
  }

  .nav-dropdown {
    position: static;
  }
  .brand a img {
    max-height: 60px;
    margin-top: 5px;
  }
  .nav-list {
    position: relative;
    top: -20px;
  }
}
@media screen and (min-width: 799px) {
  .nav-list {
    display: block !important;
    position: relative;
  }
}
#nav-toggle {
  position: absolute;
  left: 18px;
  top: 5px;
  cursor: pointer;
  padding: 10px 35px 16px 0px;
}
#nav-toggle span,
#nav-toggle span:before,
#nav-toggle span:after {
  cursor: pointer;
  border-radius: 1px;
  height: 5px;
  width: 35px;
  background: #ffffff;
  position: absolute;
  display: block;
  content: '';
  transition: all 300ms ease-in-out;
}
#nav-toggle span:before {
  top: -10px;
}
#nav-toggle span:after {
  bottom: -10px;
}
#nav-toggle.active span {
  background-color: transparent;
}
#nav-toggle.active span:before,
#nav-toggle.active span:after {
  top: 0;
}
#nav-toggle.active span:before {
  transform: rotate(45deg);
}
#nav-toggle.active span:after {
  transform: rotate(-45deg);
}
</style>
